"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//update >> quantity-input
//remove >> cart-remove-button
const selectors = {
  sidecart: '[data-sidecart]',
  sidecartOpen: '[data-sidecart-open]',
  sidecartClose: '[data-sidecart-close]',
  sidecartItemsDecrease: '[data-sidecart-item-decrease]',
  sidecartItemIncrease: '[data-sidecart-item-increase]',
  sidecartItemRemove: '[data-sidecart-item-remove]',
  headerCartCount: '[data-cart-count]',
  headerCartCountQuiz: '[data-quiz-result-cart-count]'
};
const attributes = {
  sidecartItemsDecrease: 'data-sidecart-item-decrease',
  sidecartItemIncrease: 'data-sidecart-item-increase',
  sidecartItemRemove: 'data-sidecart-item-remove',
  sidecartItemIndex: 'data-sidecart-item-index',
  sidecartOpen: 'data-sidecart-open',
  sidecartOpen: 'data-sidecart-close'
};
const classes = {
  sidecartOpen: 'sidecart-opened'
};

const fetchCart = async function (async) {
  var root_url = window.langify.locale.root_url != '/' ? window.langify.locale.root_url : '';
  var req = fetch(root_url + "/cart.js");
  
  if (async) {
    return req.then(response => response.json());
  } else {
    var res = await req;
    return await res.json();
  }
};

const httpInterceptor = async function (urlmatchs, callback) {
  var responseMatchesAnyUrl = function (requestUrl, urls) {
    if (!Array.isArray(urls)) urls = [urls];

    for (const url of urls) {
      if (!requestUrl.includes(url)) continue;
      return true;
    }

    return false;
  }; // Intercept fetch.


  const constantMock = window.fetch;

  window.fetch = function () {
    return new Promise((resolve, reject) => {
      constantMock.apply(this, arguments).then(async response => {
        try {
          if (responseMatchesAnyUrl(response.url, urlmatchs) && response.type != "cors" && response.ok) {
            let json = await response.clone().json();
            if (typeof callback === "function") await callback(json, response.url);
          }
        } catch (err) {
          console.error("Something went wrong while intercepting cart update", err);
        }

        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  }; // Intercept Ajax.


  let send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('readystatechange', async function () {
      if (responseMatchesAnyUrl(this.responseURL, urlmatchs) && this.readyState === 4 && this.status == 200) {
        if (typeof callback === "function") await callback(JSON.parse(this.response), this.responseURL);
      }
    }, false);
    send.apply(this, arguments);
  }; // TODO: Listen to HTML form submits.
  // Intercept HTML Forms.


  document.addEventListener("submit", function (e) {
    // Valid the target.
    if (!e.target || e.target.tagName.toLowerCase() !== "form" || e.target.matches('[sz-no-block]')) return; // Validate the URL.

    var form = e.target;
    var actionUrl = new URL(form.action);
    var actionPath = actionUrl.pathname;
    if (!actionPath.includes('/cart')) return;
    const XHR = new XMLHttpRequest();
    const FD = new FormData(form);
    const self = this; // Define what happens on successful data submission

    XHR.addEventListener("load", async function (event) {
      if (typeof callback === "function") await callback(undefined, form.action);
    }); // Define what happens in case of error

    XHR.addEventListener("error", function (event) {
      console.log("Error submitting form", event); // Add a custom tag & resubmit the form in order to allow the site to handle the error.

      form.setAttribute('sz-no-block', "");
      form.submit();
    }); // Set up our request

    XHR.open("POST", actionPath); // The data sent is what the user provided in the form

    XHR.send(FD);
    e.preventDefault();
  }.bind(this));
};

class SideCart {
  constructor() {
    _defineProperty(this, "_handleHeaderClick", () => {
      if (this.elements.container.classList.contains(classes.sidecartOpen)) {
        this._closeSideCart();
      } else {
        this._openSideCart();
      }
    });

    _defineProperty(this, "_handleItemClick", ({
      currentTarget
    }) => {
      if (currentTarget.hasAttribute(attributes.sidecartItemsDecrease)) {
        this._updateItem(parseInt(currentTarget.getAttribute(attributes.sidecartItemsDecrease)) - 1, currentTarget.getAttribute(attributes.sidecartItemIndex));
      } else if (currentTarget.hasAttribute(attributes.sidecartItemIncrease)) {
        this._updateItem(parseInt(currentTarget.getAttribute(attributes.sidecartItemIncrease)) + 1, currentTarget.getAttribute(attributes.sidecartItemIndex));
      } else if (currentTarget.hasAttribute(attributes.sidecartItemRemove)) {
        this._updateItem(0, currentTarget.getAttribute(attributes.sidecartItemIndex));
      }
    });

    _defineProperty(this, "_handleCartUpdates", async function (res, url) {
      this._renderCart(true);
    });

    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;

    this._setupEventListeners(); // Detect cart interactions


    httpInterceptor.bind(this)(["/cart/add", "/cart/change"], this._handleCartUpdates.bind(this));
  }

  _getElements() {
    const container = document.querySelector(selectors.sidecart);
    return container ? {
      container,
      sidecartOpen: document.querySelector(selectors.sidecartOpen),
      sidecartClose: container.querySelectorAll(selectors.sidecartClose),
      sidecartItemsDecrease: container.querySelectorAll(selectors.sidecartItemsDecrease),
      sidecartItemIncrease: container.querySelectorAll(selectors.sidecartItemIncrease),
      sidecartItemRemove: container.querySelectorAll(selectors.sidecartItemRemove)
    } : {};
  }

  _setupEventListeners() {
    this.elements.sidecartOpen.addEventListener('click', this._handleHeaderClick);
    this.elements.sidecartClose.forEach(element => {
      element.addEventListener('click', this._handleHeaderClick);
    });
    this.elements.sidecartItemsDecrease.forEach(element => {
      element.addEventListener('click', this._handleItemClick);
    });
    this.elements.sidecartItemIncrease.forEach(element => {
      element.addEventListener('click', this._handleItemClick);
    });
    this.elements.sidecartItemRemove.forEach(element => {
      element.addEventListener('click', this._handleItemClick);
    });
  }

  _openSideCart() {
     if(window.openCart) window.openCart();
    if (!document.querySelector('body').classList.contains('template-cart')) {
      this.elements.container.classList.add(classes.sidecartOpen);
    }
  }

  _closeSideCart() {
    this.elements.container.classList.remove(classes.sidecartOpen);
  }

  _updateItem(quantity, line) {
    const body = JSON.stringify({
      line,
      quantity
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(),
      ...{
        body
      }
    }).then(response => {
      return response.text();
    }).then(state => {//this._renderCart(true);
    }).catch(error => {
      console.error(error);
    });
  }

  _setTotalPrice(cart) {
    this.elements.sidecartTotal.textContent = cart.total_price;
  }

  _renderCart(openSideCart) {
    var self = this;
    var root_url = window.langify.locale.root_url != '/' ? window.langify.locale.root_url : '';
    return fetch(root_url + '/cart?view=drawer&timestamp=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (content) {
      content.text().then(function (html) {
        self._replaceContent(html);
      });
      if (openSideCart) self._openSideCart();
    });
  }

  async _replaceContent(html) {
    var tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    var cartNodeParent = this.elements.container.querySelector('.sidecart__container').parentNode;
    var currentScrollPosition = this.elements.container.querySelector('.sidecart__main').scrollTop;
    cartNodeParent.replaceChild(tempElement.querySelector('.sidecart__container'), this.elements.container.querySelector('.sidecart__container'));
    this.elements.container.querySelector('.sidecart__main').scrollTop = currentScrollPosition;
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;

    this._setupEventListeners();

    var cart = await fetchCart();

    if (document.querySelector(selectors.headerCartCount) != null) {
      document.querySelector(selectors.headerCartCount).textContent = cart.item_count;
    }

    if (document.querySelector(selectors.headerCartCountQuiz) != null) {
      document.querySelector(selectors.headerCartCountQuiz).textContent = cart.item_count;
    }
  }

}